import styled from 'styled-components'
import styledMap from 'styled-map'
import { layout, LayoutProps, margin, MarginProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { gap, GapProps } from 'Services/Styles'

interface VariantColorProps {
  secondary?: boolean
  danger?: boolean
}

interface VariantSizeProps {
  large?: boolean
  small?: boolean
}

type Props = MarginProps &
  LayoutProps &
  VariantColorProps &
  VariantSizeProps &
  GapProps

const backgroundColorMap = styledMap({
  default: themeGet('colors.secondary.main'),
  secondary: themeGet('colors.background.paperElevation2'),
})

const colorMap = styledMap({
  default: themeGet('colors.success.contrast'),
  secondary: themeGet('colors.text.primary'),
})

const hoverBackgroundColorMap = styledMap({
  default: themeGet('colors.secondary.dark'),
  secondary: themeGet('colors.background.paperElevation0'),
})

const heightMap = styledMap({
  large: 42,
  default: 36,
  small: 30,
})

const fontSizeMap = styledMap({
  large: 16,
  default: 14,
  small: 12,
})

const shouldForwardProp = (prop: string) =>
  !['secondary', 'danger', 'large', 'small', 'minWidth', 'width'].includes(prop)

const Button = styled.button.withConfig({ shouldForwardProp })<Props>`
  height: ${heightMap}px;
  padding: 0 ${themeGet('space.5')}px;
  font-family: inherit;
  font-size: ${fontSizeMap}px;
  flex-shrink: 0;
  font-weight: ${themeGet('fontWeights.2')};
  letter-spacing: -0.2px;
  color: ${colorMap};
  background-color: ${backgroundColorMap};
  border-radius: 21px;
  box-shadow: none;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: ${hoverBackgroundColorMap};
    border-color: ${hoverBackgroundColorMap};
  }

  &:disabled {
    cursor: default;
    opacity: 30%;
    color: ${colorMap};

    &:hover {
      color: ${colorMap};
      background-color: ${backgroundColorMap};
    }
  }

  ${margin}
  ${layout}
    ${gap}
`

export default Button
